export enum AuthMode {
  Local = "Local",
  LDAP = "LDAP",
  ADFS = "ADFS",
  OKTA = "OKTA",
}
